import { useState } from 'react';

import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import './App.css';
import { ThemeProvider } from './contexts/ThemeContext';

//**
// Components
//**
import Header from './components/common/Header';
import ClientAuth from './components/pages/clients/auth/ClientAuth';
import Login from './components/pages/users/Login';
import Register from './components/pages/users/Register';
import Dashboard from './components/pages/admin/Dashboard';
import ClientSecret from './components/common/ClientSecret';
import InErrorPage from './components/pages/InError/InErrorPage';
import ShopPage from './components/pages/clients/shop/ShopPage';
import ProductPage from './components/pages/clients/shop/product/ProductPage';
import Privacy from './components/pages/clients/other/Privacy';
import Terms from './components/pages/clients/other/Terms';
import ShippingPolicy from './components/pages/clients/other/ShippingPolicy';
import ProfilePage from './components/pages/clients/profile/ProfilePage';
import ContactPage from './components/pages/clients/contact/ContactPage';
import CheckoutPage from './components/pages/clients/checkout/ChekoutPage';
import SuccessPage from './components/pages/clients/checkout/commandStatus/SuccessPage';
import CancelPage from './components/pages/clients/checkout/commandStatus/CancelPage';
import CommandsPage from './components/pages/clients/commands/CommandsPage';
import PasswordForget from './components/pages/clients/auth/PasswordForget';

function AppContent() {
  const [currentCommand, setCurrentCommand] = useState(null);

  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<ClientAuth />} />
        <Route path="/client-auth" element={<ClientAuth />} />
        <Route path="/reset-password" element={<PasswordForget />} />
        <Route path="/reset-password/:token" element={<PasswordForget />} />
        <Route path="/client-secret" element={<ClientSecret />} />
        <Route path='/client/profile' element={<ProfilePage currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />} />
        <Route path='/client/contact' element={<ContactPage currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />} />
        <Route path='/client/checkout' element={<CheckoutPage setCurrentCommand={setCurrentCommand} currentCommand={currentCommand} />} />
        <Route path='/client/checkout/success/:id' element={<SuccessPage currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />} />
        <Route path='/client/checkout/cancel/:id' element={<CancelPage currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />} />
        <Route path="/admin/login" element={<Login />} />
        {
          
          //Commenter le register pour ne pas permettre à un utilisateur de se créer un compte
          //<Route path="/admin/register" element={<Register />} />
        }
        <Route path="/admin/dashboard" element={<Dashboard />} />
        <Route path="/shop" element={<ShopPage currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />} />
        <Route path="/shop/product/:id" element={<ProductPage currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />} />
        <Route path="/shop/cart/:commandId" element={<></>} />
        <Route path="/client/commands" element={<CommandsPage currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />} />
        <Route path="/shipping-policy" element={<ShippingPolicy currentCommand={currentCommand} setCurrentCommand={setCurrentCommand} />} />
        <Route path="*" element={<InErrorPage errorCode={404} errorMessage="Page Not Found" />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <AppContent />
      </Router>
    </ThemeProvider>
  );
}

export default App;
